/* article-pro.js — United HVAC Motors blog article behaviour.
   New file, no dependencies. Progress bar, table scroll wrappers, "In this guide" from H2s,
   mobile CTA bar, and dataLayer events for the GTM container already in theme.liquid. */
(function () {
  'use strict';
  var article = document.querySelector('[data-uhm-article]');
  if (!article) return;

  var body = article.querySelector('[data-uhm-body]');
  var variant = article.getAttribute('data-uhm-variant') || 'pro';
  var pushed = {};

  function push(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      payload.uhm_variant = variant;
      payload.uhm_article = window.location.pathname;
      window.dataLayer.push(payload);
    } catch (e) { /* analytics must never break the page */ }
  }

  function slug(text) {
    return String(text).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }

  /* ---- tables: horizontal scroll wrapper (content untouched) ---- */
  if (body) {
    Array.prototype.forEach.call(body.querySelectorAll('table'), function (table) {
      if (table.parentElement && table.parentElement.classList.contains('uhm-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'uhm-table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  /* ---- "In this guide" from H2s ---- */
  var toc = article.querySelector('[data-uhm-toc]');
  var tocList = article.querySelector('[data-uhm-toc-list]');
  var headings = [];
  if (body) {
    headings = Array.prototype.filter.call(body.querySelectorAll('h2'), function (h) {
      return h.textContent.trim().length > 1 && !h.closest('.uhm-inline, .uhm-end, .c-banner-container, .article-product-list, .article-banner-list');
    });
  }
  if (toc && tocList && headings.length >= 3) {
    var seen = {};
    headings.forEach(function (h, i) {
      if (!h.id) {
        var base = slug(h.textContent) || ('section-' + (i + 1));
        var id = base, n = 2;
        while (seen[id] || document.getElementById(id)) { id = base + '-' + n++; }
        h.id = id;
      }
      seen[h.id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', function () { push({ event: 'uhm_toc_click', uhm_heading: h.id }); });
      li.appendChild(a);
      tocList.appendChild(li);
    });
    toc.hidden = false;

    if ('IntersectionObserver' in window) {
      var items = tocList.querySelectorAll('li');
      var activeIndex = -1;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = headings.indexOf(entry.target);
          if (idx === -1 || idx === activeIndex) return;
          activeIndex = idx;
          Array.prototype.forEach.call(items, function (li, j) { li.classList.toggle('is-active', j === idx); });
        });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
      headings.forEach(function (h) { io.observe(h); });
    }
  }

  /* ---- reading progress ---- */
  var progress = article.querySelector('[data-uhm-progress]');
  var ticking = false;
  function updateProgress() {
    if (!progress) return;
    var rect = article.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var done = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
    progress.style.transform = 'scaleX(' + done.toFixed(3) + ')';
  }

  /* ---- mobile bar: show after a screen of reading, hide once the end band is in view ---- */
  var bar = article.querySelector('[data-uhm-mobilebar]');
  var endBand = article.querySelector('[data-uhm-end]');
  var endVisible = false;
  if (bar) {
    bar.hidden = false;
    article.classList.add('uhm-has-mobilebar');
    if (endBand && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        endVisible = entries[0].isIntersecting;
        updateBar();
      }, { threshold: 0.2 }).observe(endBand);
    }
  }
  function updateBar() {
    if (!bar) return;
    var show = window.scrollY > 480 && !endVisible;
    if (show && !bar.classList.contains('is-visible')) {
      bar.classList.add('is-visible');
      if (!pushed['mobile-bar']) { pushed['mobile-bar'] = true; push({ event: 'uhm_b2b_cta_view', uhm_position: 'mobile-bar' }); }
    } else if (!show) {
      bar.classList.remove('is-visible');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { updateProgress(); updateBar(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* ---- analytics: CTA views (once per position), CTA clicks, tool clicks ---- */
  if ('IntersectionObserver' in window) {
    var viewIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var pos = entry.target.getAttribute('data-uhm-cta');
        if (pushed[pos]) return;
        pushed[pos] = true;
        push({ event: 'uhm_b2b_cta_view', uhm_position: pos });
        viewIO.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    Array.prototype.forEach.call(article.querySelectorAll('[data-uhm-cta]'), function (el) { viewIO.observe(el); });
  }
  article.addEventListener('click', function (ev) {
    var cta = ev.target.closest && ev.target.closest('[data-uhm-cta-link]');
    if (cta) { push({ event: 'uhm_b2b_cta_click', uhm_position: cta.getAttribute('data-uhm-cta-link'), uhm_href: cta.getAttribute('href') }); return; }
    var tool = ev.target.closest && ev.target.closest('[data-uhm-tool]');
    if (tool) { push({ event: 'uhm_tool_click', uhm_href: tool.getAttribute('href') }); }
  });
})();
